<div [style]="cssVars()">
    <router-outlet />

    <div class="stacked-sub-pages-modal" [class.hidden]="activeRouterLevel === 0">
        <div [class.hidden]="activeRouterLevel !== 1">
            <router-outlet name="level1" />
        </div>

        <div [class.hidden]="activeRouterLevel !== 2">
            <router-outlet name="level2" />
        </div>
    </div>
</div>
